import { render, staticRenderFns } from "./PageAddNewPassword.vue?vue&type=template&id=08f91fe6&scoped=true"
import script from "./PageAddNewPassword.vue?vue&type=script&lang=js"
export * from "./PageAddNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f91fe6",
  null
  
)

export default component.exports